

















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import format from 'date-fns/format';

@Component({})
export default class CouponInfo extends Vue {
  @Prop({ type: [Object, Array, String, Number,Date] }) value!: any;
  @Prop({ type: [Object, Array, String, Number,Date], default:'date'}) type!: any;
  @Prop({ type: [Object, Array, String, Number,Date], default:'时间'}) placeholder!: any;
  @Prop({ type: [Boolean]}) disabled!: any;
  @Prop({ type: [Object, Array, String, Number,Date]}) minDate!: any;

  show = false;
  confirm(val: any) {
    this.$emit("change", val);
    this.$emit("input", val);
    this.show = false
  }
  cancel(){
      this.show = false
  }
  get currentDate() {
    return this.value ? this.type=="time"?this.value:new Date(this.value) : this.type=="time"?'08:00':new Date();
  }
  get model() {
    if (this.type=='time') {
        return this.value||'';
    }else{
    return this.value?format(this.value,'YYYY.MM.DD'):'';
    }
  }
}
